module.exports = "<button (click)=\"openSidenav.emit()\" class=\"button\" fxHide.gt-sm mat-icon-button>\r\n  <mat-icon>menu</mat-icon>\r\n</button>\r\n"